import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/auth-context';
import { apiClient } from '@/lib/api-client';

export interface MyPayRate {
  rate_type: 'hourly' | 'daily' | null;
  per_diem_rate: string | null;
  effective_date: string | null;
  fallback_rate: string;
}

export function useMyPayRate(asOf?: string, enabled = true) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['my-pay-rate', user?.organization, user?.id, asOf || null],
    enabled: enabled && !!user,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    queryFn: async (): Promise<MyPayRate> => {
      const response = await apiClient.get<MyPayRate>('/api/v1/payroll/my-pay-rate/', {
        params: asOf ? { as_of: asOf } : undefined,
      });
      return response.data;
    },
  });
}
